export { default } from "./Feedback"

export const reasons = [
	{
		id: 1,
		text: 'Didn’t get any applicants.',
	},
	{
		id: 2,
		text: 'Wasn’t able to find qualified applicants. ',
	},
	{
		id: 3,
		text: 'Already hired an applicant.',
	},
	{
		id: 4,
		text: 'Other',
	},
]
